import { USER_GLB } from "../types";
import api from "../api";

export const userGlb = glb => ({
  type: USER_GLB,
  glb
});

export const getUserGlb = () => dispatch =>
  api.lpUtil.getUserGlb().then(res => {
    if (res.status === 200) {
      if (res.data) {
        localStorage.userGlb = JSON.stringify(res.data.Data);
        dispatch(userGlb(res.data.Data));
      } else {
        localStorage.loginFailed = "Unable to fetch uset GLB";
      }
      Promise.resolve(res);
    } else {
      Promise.resolve(res);
    }
  });



// WEBPACK FOOTER //
// ./src/actions/userGlb.js